<template>
  <div class="col-12">
    <div class="col-4 px-0 b-import__btn-wrap">
      <div class="b-btn b-import__btn">
        {{ $t('CONTENT.choose_file') }}
      </div>
      <input
        type="file"
        class="b-input b-import__btn-input"
        @change="onFileChange($event, true)"
      >
    </div>
    <div v-if="showFileInfo">
      <div
        v-if="fileName"
        class="col-12 px-0 b-import__file-info mt-4 py-2"
      >
        <dynamic-icon
          class="b-icon b-icon_color_gray mr-2"
          icon="xls"
        />{{ fileName }}
      </div>
      <div
        v-if="isShowWarning"
        class="b-notification b-notification__warning p-2"
      >
        <div class="b-server-error__icon-wrap b-server-error__icon-wrap_type_duplicate p-2 mr-2">
          <dynamic-icon icon="warning" />
        </div>
        <div class="b-server-error__text">
          {{ warningMessage }}
        </div>
        <div class="b-form__container b-form__container_type_flex mt-3">
          <button class="b-btn b-btn_type_primary" @click.prevent="confirmUpload">
            {{ $t('CONTENT.confirmSave') }}
          </button>
          <button
            class="b-btn b-btn_type_empty"
            @click.prevent="cancelWarning"
          >
            {{ $t('CONTENT.cancel') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: ['importType', 'assetComponent', 'courseName', 'courseId'],
  data() {
    return {
      file: null,
      fileName: null,
      showFileInfo: true,
      isShowWarning: false,
      warningMessage: null,
    };
  },
  created() {
    this.$parent.$on('hideFileInfo', () => {
      this.showFileInfo = false;
    });
  },
  methods: {
    async onFileChange(e, useAdditionalValidation) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      this.file = files[0];
      this.fileName = this.file.name;

      await this.uploadFile(useAdditionalValidation);

      e.target.value = '';
    },

    async confirmUpload() {
      if (!this.file) return;
      await this.uploadFile(false);
      this.isShowWarning = false;
      this.warningMessage = null;
    },


    async uploadFile(useAdditionalValidation) {
      const formData = new FormData();
      formData.append('file', this.file);
      if (this.courseName) formData.append('name', this.courseName);
      if (this.courseId) formData.append('fileid', this.courseId);

      let actionPath = null;
      let response = null;

      try {
        this.$fileLoadingManager.startLoading();

        if (this.importType === 'manualChart') {
          response = await this.$store.dispatch(
            'eventRegistryPlugin/parseManualChartFromExcel',
            { file: formData, assetComponentId: this.assetComponent.idInDB },
          );
        } else {
          if (this.importType === 'discountRate') {
            actionPath = `discountRatesPlugin/${this.importType}Import`;
          } else {
            actionPath = `${this.importType}Import`;
          }

          const payload = { file: formData };
          if (this.importType === 'event') payload.useAdditionalValidation = useAdditionalValidation;

          response = await this.$store.dispatch(actionPath, payload);


          if (this.importType === 'event' && useAdditionalValidation) {
            let warning = null;

            if (response && response.warning) warning = response.warning;
          else if (response && response.data && response.data.warning) warning = response.data.warning;
            else if (response && response.headers && response.headers['x-warning']) {
              try {
                warning = JSON.parse(decodeURIComponent(response.headers['x-warning']));
              } catch {}
            }

            if (warning) {
              this.isShowWarning = true;
              this.warningMessage = warning.message;
              return;
            }
          }
        }

        this.showFileInfo = true;
        this.$emit('finishUpload', response);
        this.$emit('getFile', formData);
      } catch (e) {
        this.$emit('uploadError', e);
      } finally {
        this.$fileLoadingManager.finishLoading();
      }
    },

    cancelWarning() {
      this.isShowWarning = false;
      this.warningMessage = null;
      this.showFileInfo = false;
      this.fileName = null;
    },
  },
};
</script>
